module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c399212f9ed1df9720ff813360923865.png";